import { render } from "./HandheldMeasurements.vue?vue&type=template&id=5da764bf"
import script from "./HandheldMeasurements.vue?vue&type=script&lang=js"
export * from "./HandheldMeasurements.vue?vue&type=script&lang=js"

import "./HandheldMeasurements.vue?vue&type=style&index=0&id=5da764bf&lang=scss"
script.render = render

export default script